import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// project-imports
import Drawer from './Drawer';
import Header from './Header';
import HorizontalBar from './Drawer/HorizontalBar';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { DRAWER_WIDTH } from 'config';
import navigation from 'menu-items';
import useConfig from 'hooks/useConfig';
import { dispatch } from 'store';
import { openDrawer } from 'store/reducers/menu';
import { MenuOrientation } from 'config';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const downXL = useMediaQuery(theme.breakpoints.down('xl'));
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { miniDrawer, menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;
  // console.log(DRAWER_WIDTH);
  // console.log(downXL, downLG);

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      dispatch(openDrawer(!downXL));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [miniDrawer]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      {!isHorizontal ? <Drawer /> : <HorizontalBar />}
      {/* pt kept separate from px/pb — that's the "extra gap above every page's content" knob;
          the spacer Toolbar right below it still has to match the fixed header's own height, so
          that part isn't shrinkable without content sliding under the header. */}
      <Box
        component="main"
        sx={{ width: `calc(100% - ${DRAWER_WIDTH}px)`, flexGrow: 1, pt: 0, px: { xs: 2, md: 3 }, pb: { xs: 2, md: 3 } }}
      >
        <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit', mb: isHorizontal ? 2 : 'inherit' }} />
        {/* maxWidth was previously driven by the `container` customization setting (persisted in
            localStorage under able-pro-material-react-ts-config), capping content at MUI's 'xl'
            breakpoint and centering it — leaving ever-larger blank gutters on both sides as the
            sidebar got narrower and freed up more width. This app has no settings UI left for a
            user to turn that setting off themselves, so content is now always full width.
            disableGutters is needed too — Container applies its own left/right padding by default
            on top of the horizontal padding the "main" Box above already adds, so without it the
            two stack into a double-wide gutter on each side. */}
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout;
